import {Layout} from 'antd';
import React, {useContext} from 'react';
import {Routes} from '../routes/Routes';
import {ApiContext} from "../ApiContext";
// import { getTheme, setTheme } from '../store/SettingsSlice';

export const AppLayout = () => {
    const {txt} = useContext(ApiContext)
    return (
        <Layout>
            {/*<Layout.Header>*/}
            {/*    {txt('web.header')}*/}
            {/*</Layout.Header>*/}
            <Layout.Content>
                <Routes/>
            </Layout.Content>
            {/*<Layout.Footer>Footer</Layout.Footer>*/}
        </Layout>
    );
};

